import { Badge as MuiBadge, type BadgeProps as MuiBadgeProps } from '@mui/material';

import type { WithoutStyleOverrides } from '../../../types/WithoutStyleOverrides';

type Props = WithoutStyleOverrides<Omit<MuiBadgeProps, 'slots' | 'slotProps'>>;

export function Badge(props: Props) {
  return <MuiBadge {...props} />;
}

export type { Props as BadgeProps };
